module.exports = __webpack_public_path__ + "img/lnb_01.76a83fcb.png";